import React from "react";
import cx from "classnames";
import {createUseStyles} from "react-jss";
import PropTypes from "prop-types";
import {Typography} from "./Typography";

const useStyles = createUseStyles(
    (theme) => ({
        button: {
            minWidth: 48,
            width: "fit-content",
            display: "flex",
            flexDirection: (props) => (props.iconRight ? "row-reverse" : "row"),
            justifyContent: "center",
            alignItems: "center",
            gap: "8px",
            whiteSpace: "nowrap",
            boxSizing: "border-box",
            cursor: "pointer",
            zIndex: 30,
            "&.type-normal": {
                height: 48,
                borderRadius: 999,
                color: theme.colors.black,
                backgroundColor: (props) => props.color,
                border: "none",
                padding: (props) => (props.label ? "11px 20px" : "0"),
                "&:hover": {
                    backgroundColor: "white",
                },
                "&:focus-visible": {
                    outline: "3px solid #ffffff",
                    outlineOffset: "4px",
                },
                "&:active": {opacity: 0.7},
            },
            "&.type-large": {
                height: 72,
                borderRadius: 999,
                color: theme.colors.black,
                backgroundColor: (props) => props.color,
                border: "none",
                padding: (props) => (props.label ? "23px 32px" : "0"),
                "&:hover": {
                    opacity: 0.7,
                },
                "&:focus-visible": {
                    outline: "3px solid #ffffff",
                    outlineOffset: "4px",
                },
                "&:active": {opacity: 1.2},
            },
            "&.outline": {
                border: `2px solid ${theme.colors.black}`,
            },
        },
        label: {
            cursor: "pointer",
            whiteSpace: "nowrap",
            lineHeight: 1,
        },
    }),
    {name: "vm"}
);

export const Button = ({
                           label="",
                           ariaLabel,
                           Icon,
                           color,
                           type="normal",
                           iconRight=false,
                           className="",
                           outline=true,
                           ...rest
                       }) => {
    const style = useStyles({
        iconRight: iconRight,
        color: color,
        label: label
    });
    const accessibleName = ariaLabel || rest["aria-label"] || (typeof label === "string" && label.length > 0 ? label : undefined);
    return (
        <button
            className={cx(className, style.button, `type-${type}`, {
                outline: outline,
            })}
            aria-label={accessibleName}
            {...rest}
        >
            {Icon && Icon}
            {label && (
                <Typography tag="label" className={style.label} size="base">
                    {label}
                </Typography>
            )}
        </button>
    );
};


